/**
 * Get a keyed array
 * @param size The size of the array
 * @returns A keyed array of unique sequential numbers
 */
export function getKeyedArray(size: number) {
    const fillArray = new Array(size).fill(1)
    const fillArrayKeys = Array.from(fillArray.keys())
    return fillArrayKeys
}
